define('SC.InfiniteScroll.1.0.0.InfiniteScroll', [
    'SC.Configuration',
    'jQuery',
    'underscore',

    'Backbone',
    'Backbone.CollectionView',

    'Facets.Browse.View',
    'Facets.Model',
    'Facets.ItemCell.View',

    'InfiniteScroll.Controls.View',
    'InfiniteScroll.GoToTop.View',

    'facets_items_collection.tpl',
    'facets_items_collection_view_cell.tpl',
    'facets_items_collection_view_row.tpl'
], function InfiniteScroll(
    Configuration,

    jQuery,
    _,

    Backbone,
    BackboneCollectionView,

    FacetsBrowseView,
    FacetsModel,
    FacetsItemCellView,

    InfiniteScrollControlsView,
    InfiniteScrollGoToTopView,

    facetsItemsCollectionTpl,
    facetsItemsCollectionViewCellTpl,
    facetsItemsCollectionViewRowTpl
) {
    'use strict';

    return {
        plp: null,

        application: null,

        facetItemEndPoint: 0,

        initialPageNumber: 1,

        numberOfPagesLoaded: 1,

        readyLoad: true,

        childIDMultiplier: 1,

        childIDprev: 1,

        hasMoreToLoad: true,

        currentURLParams: '',

        currentPageNum: 1,

        configuration: {},

        pageLoaded: 1,

        loadedPages: [],

        urlPath: '',

        initialize: function initialize(options) {
            this.plp = options.plp;
            this.application = options.application;
            this.configuration = Configuration.get('infiniteScroll');
            this.overridePagination();
        },

        overridePagination: function overridePagination() {
            var self = this;
            var currentParams = window.location.hash !== '' ? window.location.hash : window.location.search;
            var i = 0;
            var currentParam;

            if (currentParams !== '') {
                currentParams = currentParams.split('?');
                if (currentParams[1] && currentParams[1].length !== 0) {
                    currentParams = currentParams[1].split('&');
                }

                for (i = 0; i < currentParams.length; i++) {
                    currentParam = currentParams[i].split('=');
                    if (currentParam[0] === 'page') {
                        this.initialPageNumber = parseInt(currentParam[1], 10);
                        this.currentPageNum = parseInt(currentParam[1], 10);
                    }
                }
            }

            this.plp.addChildViews(
                this.plp.PLP_VIEW, {
                    'GlobalViews.Pagination': {
                        'InfiniteScrollGoToTop': {
                            childViewIndex: 6,
                            childViewConstructor: function childViewConstructor() {
                                return new InfiniteScrollGoToTopView({
                                    plp: self.plp
                                });
                            }
                        }
                    }
                }
            );

            if (this.initialPageNumber > 1) {
                this.plp.addChildViews(
                    this.plp.PLP_VIEW, {
                        'Facets.FacetsDisplay': {
                            'InfiniteScrollControlTop': {
                                childViewIndex: 3,
                                childViewConstructor: function childViewConstructor() {
                                    return new InfiniteScrollControlsView({
                                        plp: self.plp,
                                        isAtTop: true,
                                        configuration: self.configuration
                                    });
                                }
                            }
                        }
                    }
                );
            }


            this.plp.addChildViews(
                this.plp.PLP_VIEW, {
                    'GlobalViews.Pagination': {
                        'InfiniteScrollControlBottom': {
                            childViewIndex: 3,
                            childViewConstructor: function childViewConstructor() { // eslint-disable-line consistent-return
                                if (self.currentPageNum !== self.plp.getPagination().pageCount) {
                                    return new InfiniteScrollControlsView({
                                        plp: self.plp,
                                        isAtTop: false,
                                        configuration: self.configuration
                                    });
                                }
                            }
                        }
                    }
                }
            );

            this.plp.removeChildView(this.plp.PLP_VIEW, 'GlobalViews.Pagination', 'GlobalViews.Pagination');
        },

        renderPage: function renderPage(options) {
            var self = this;
            var newFacetItemsView = {};
            var childViewIndex = (options.isLoadedAtTop) ? 10 - parseInt(this.childIDprev, 10) : 10 + options.pageNumber;

            newFacetItemsView['Facets.Items' + this.childIDMultiplier + '' + options.pageNumber] = {
                childViewIndex: childViewIndex,
                childViewConstructor: function childViewConstructor() {
                    return new BackboneCollectionView({
                        childTemplate: options.template,
                        childView: FacetsItemCellView,
                        childViewOptions: {
                            application: self.application
                        },
                        viewsPerRow: parseInt(options.columns, 10),
                        collection: options.facetsModel.get('items'),
                        cellTemplate: facetsItemsCollectionViewCellTpl,
                        rowTemplate: facetsItemsCollectionViewRowTpl,
                        template: facetsItemsCollectionTpl,
                        context: {
                            keywords: options.keywords
                        }
                    });
                }
            };

            this.plp.addChildViews(this.plp.PLP_VIEW, {
                'Facets.Items': newFacetItemsView
            });

            this.numberOfPagesLoaded++;
            this.application.getLayout().currentView.render();
            this.plp.cancelableTrigger('InfiniteScroll-afterRenderPage', {
                isLoadedAtTop: options.isLoadedAtTop,
                pageNumber: options.pageNumber,
                initialPageNumber: parseInt(self.initialPageNumber, 10),
                numberOfPagesLoaded: parseInt(self.numberOfPagesLoaded, 10)
            });
        },

        loadPage: function loadPage(options) {
            var self = this;
            var facetsModel = new FacetsModel();
            var pageNum = options.isLoadedAtTop ? this.getPrevPage() : this.getNextPage();
            var pagination = this.plp.getPagination();
            var template = this.plp.getDisplay() && this.plp.getDisplay().template;
            var columns = this.plp.getDisplay() && this.plp.getDisplay().columns;
            var keywords = this.plp.getSearchText();
            var itemSearchApiParams;
            var filters = this.plp.getFilters();
            var categoryInfo = this.plp.getCategoryInfo();
            var sorting = this.plp.getSorting();
            filters = _.pluck(filters, 'value');

            pagination.currentPage = pageNum;

            this.plp.cancelableTrigger('InfiniteScroll-beforeRenderPage', {
                isLoadedAtTop: options.isLoadedAtTop
            });

            itemSearchApiParams = {
                pageNumber: pageNum,
                template: template,
                keywords: keywords,
                columns: columns,
                pageSize: this.plp.getPageSize().items,
                filters: filters,
                sorting: sorting
            };

            if ( categoryInfo ) {
                itemSearchApiParams.commercecategoryurl = categoryInfo.fullurl;
                itemSearchApiParams.sort  = sorting.id.replace('relevance', 'commercecategory')
            }

            facetsModel.fetch({
                url: this.plp.getUrl(pagination),
                data: itemSearchApiParams
            }).done(function success() {
                if (facetsModel.get('items').length === 0) {
                    self.plp.cancelableTrigger('InfiniteScroll-noResults');
                    self.application.getLayout().currentView.render();
                } else {
                    self.renderPage({
                        pageNumber: pageNum,
                        isLoadedAtTop: options.isLoadedAtTop,
                        template: template,
                        columns: columns,
                        keywords: keywords,
                        facetsModel: facetsModel
                    });
                }
            });
        },

        getNextPage: function getNextPage() {
            return parseInt(this.numberOfPagesLoaded, 10) + parseInt(this.initialPageNumber, 10);
        },

        getPrevPage: function getPrevPage() {
            return parseInt(this.initialPageNumber, 10) - 1;
        },

        recalcFacetItemEndPoint: function facetItemEndPoint() {
            var facetItemView = jQuery('[data-view="Facets.Items"]');
            if (facetItemView.length !== 0) {
                this.facetItemEndPoint = parseInt(facetItemView.offset().top, 10) +
                    (parseInt(facetItemView.outerHeight(), 10) - parseInt(window.innerHeight, 10) - 400);
            } else {
                jQuery('.infinite-scroll-btn-holder').remove();
            }
            return this.facetItemEndPoint;
        },

        updateLoadedPagePoints: function updateLoadedPagePoints() {
            var self = this;
            var pn = self.initialPageNumber;
            var ctr = 1;

            this.loadedPages = [];
            jQuery('[data-view="Facets.Items"]').children().each(function eachFacetDiv() {
                var offsetTop = jQuery(this).first().offset() && jQuery(this).first().offset().top;
                offsetTop = (offsetTop && ctr !== 1) ? parseInt(offsetTop, 10) : 0;
                ctr++;

                self.loadedPages.push({
                    scrollStartPoint: offsetTop,
                    scrollEndpoint: offsetTop + parseInt(jQuery(this).first().height(), 10),
                    pageNumber: pn++
                });
            });
        },

        resetFacetResult: function resetFacetResult() {
            if (this.numberOfPagesLoaded !== 1) {
                while (this.numberOfPagesLoaded >= this.initialPageNumber) {
                    this.plp.removeChildView(
                        this.plp.PLP_VIEW, // eslint-disable-line
                        'Facets.Items',
                        'Facets.Items' + this.childIDMultiplier + '' + this.numberOfPagesLoaded
                    );
                    this.numberOfPagesLoaded--;
                }
                // sometimes divs are not removed after removeChildView because page has already been rendered
                jQuery('[data-view="Facets.Items"] > div').slice(1).remove();
            }

            this.plp.removeChildView(
                this.plp.PLP_VIEW, // eslint-disable-line
                'Facets.FacetsDisplay',
                'InfiniteScrollControlTop'
            );

            this.numberOfPagesLoaded = 1;
            this.initialPageNumber = 1;
            this.hasMoreToLoad = (this.plp.getPagination() && (this.plp.getPagination().pageCount > 1));
            this.recalcFacetItemEndPoint();
            this.updateLoadedPagePoints();
            this.childIDMultiplier++;
        },

        updatePageURL: function updatePageURL(amountScrolled) {
            var newURLParams = [];
            var currentParams = '';
            var currentParam;
            var hasPageParam = false;
            var i = 0;

            var currentPage = _.filter(this.loadedPages, function checkCurrentPage(loadedPage) {
                return (amountScrolled >= loadedPage.scrollStartPoint &&
                amountScrolled < loadedPage.scrollEndpoint);
            });
            var uRLHash = window.location.pathname;
            uRLHash = uRLHash.substring(1, uRLHash.length);


            if (currentPage.length !== 0 && (currentPage[0] && currentPage[0].pageNumber)) {
                if (currentPage[0].pageNumber !== this.currentPageNum) {
                    this.currentPageNum = currentPage[0].pageNumber;
                    currentParams = window.location.hash !== '' ? window.location.hash : window.location.search;

                    if (currentParams !== '') {
                        currentParams = currentParams.split('?');

                        if (window.location.hash !== '') {
                            uRLHash = currentParams[0].replace('#', '');
                        } else {
                            uRLHash = window.location.pathname;
                            uRLHash = uRLHash.substring(1, uRLHash.length);
                        }

                        if (currentParams[1] && currentParams[1].length !== 0) {
                            currentParams = currentParams[1].split('&');

                            for (i = 0; i < currentParams.length; i++) {
                                currentParam = currentParams[i].split('=');

                                if (currentParam[0] === 'page') {
                                    hasPageParam = true;
                                    newURLParams.push(currentParam[0] + '=' + (currentPage[0].pageNumber));
                                } else {
                                    newURLParams.push(currentParam[0] + '=' + currentParam[1]);
                                }
                            }
                        }
                    }

                    if (!hasPageParam) {
                        newURLParams.push('page=' + (currentPage[0].pageNumber));
                    }
                }
            }

            if (newURLParams.length !== 0) {
                Backbone.history.navigate(uRLHash + '?' + (newURLParams.join('&')), {
                    trigger: false,
                    replace: true
                });
            }
        },

        onEvents: function onEvents() {
            var self = this;

            this.plp.on('afterSetSorting', function afterSetSorting() {
                self.resetFacetResult();
            });

            this.plp.on('afterSetPageSize', function afterSetPageSize() {
                self.resetFacetResult();
            });

            this.plp.on('beforeSetDisplay', function beforeSetDisplay() {
                self.resetFacetResult();
            });

            this.plp.on('afterSetFilters', function afterSetFilters() {
                self.resetFacetResult();
            });

            this.plp.on('afterSetSearchText', function afterSetSearchText() {
                self.resetFacetResult();
            });

            this.plp.on('InfiniteScroll-beforeRenderPage', function beforeRenderPage() {
                self.readyLoad = false;
            });

            this.plp.on('InfiniteScroll-afterRenderPage', function afterRenderPage(options) {
                var amountScrolled = window.pageYOffset;
                if (options.pageNumber === self.plp.getPagination().pageCount) {
                    self.hasMoreToLoad = false;
                }

                self.recalcFacetItemEndPoint();

                if (options.isLoadedAtTop) {
                    self.childIDprev++;
                    self.initialPageNumber--;
                    if (self.initialPageNumber === 1) {
                        jQuery('#btn-prev-page').remove();
                    }
                }

                if ((!options.isLoadedAtTop) && (self.pageLoaded < self.configuration.pageLoadLimit)) {
                    self.pageLoaded++;
                    self.readyLoad = false;
                    self.plp.cancelableTrigger('InfiniteScroll-loadMorePage', {
                        isLoadedAtTop: false
                    });
                } else {
                    self.pageLoaded = 1;
                    self.readyLoad = true;
                }

                self.updateLoadedPagePoints();
                if (options.isLoadedAtTop) {
                    self.updatePageURL(amountScrolled);
                }
            });

            this.plp.on('InfiniteScroll-loadMorePage', function loadMorePage(options) {
                self.loadPage({
                    isLoadedAtTop: options.isAtTop
                });
            });

            this.plp.on('afterShowContent', function afterShowContent() {
                var facetItemView = jQuery('[data-view="Facets.Items"]');
                var numOfFacetsDiv = jQuery('[data-view="Facets.Items"] > .facets-items-collection-view-row').length;
                var uRLHash = window.location.pathname;
                var uRLPath;

                if (window.location.hash !== '') {
                    uRLHash = window.location.hash;
                    uRLHash = uRLHash.split('?');
                    uRLPath = uRLHash[0].replace('#', '');
                } else {
                    uRLPath = window.location.pathname;
                    uRLPath = uRLPath.substring(1, uRLPath.length);
                }

                if (self.urlPath === '') {
                    self.urlPath = uRLPath;
                }

                if (facetItemView.length !== 0) {
                    if (numOfFacetsDiv > 0) {
                        jQuery('[data-view="Facets.Items"]').wrapInner('<div></div>');
                        self.updateLoadedPagePoints();
                    } else {
                        self.updateLoadedPagePoints();
                    }

                    if (self.urlPath !== uRLPath) {
                        self.urlPath = uRLPath;
                        self.resetFacetResult();
                    }

                    jQuery(window).unbind('scroll');
                    jQuery(window).bind('scroll', function windowScroll() {
                        var amountScrolled = window.pageYOffset;
                        var facetItemEndPoint;
                        var fixedHeader = Configuration.get('header.fixedHeader');

                        if (fixedHeader) {
                            var y = jQuery(this).scrollTop();
                            if (y >= 300) {
                                jQuery('body').addClass('fixed-header');
                            }
                            if (y < 1) {
                                jQuery('body').removeClass('fixed-header');
                            }
                        }

                        facetItemView = jQuery('[data-view="Facets.Items"]');

                        self.updatePageURL(amountScrolled);

                        if (self.configuration.enableAutoScroll) {
                            if (facetItemView && facetItemView.length && facetItemView.length !== 0) {
                                facetItemEndPoint = self.recalcFacetItemEndPoint();
                                if (amountScrolled >= facetItemEndPoint && self.readyLoad && self.hasMoreToLoad) {
                                    self.plp.cancelableTrigger('InfiniteScroll-loadMorePage', {
                                        isLoadedAtTop: false
                                    });
                                }
                            }
                        }

                        if (amountScrolled > 1500) {
                            jQuery('.infinite-scroll-top').fadeIn('slow');
                        } else {
                            jQuery('.infinite-scroll-top').fadeOut('slow');
                        }
                    });
                } else {
                    jQuery('.infinite-scroll-btn-holder').remove();
                }
            });
        },

        mountToApp: function mountToApp(container) {
            var plp = container.getComponent('PLP');
            if (plp) {
                this.initialize({
                    plp: plp,
                    application: container
                });

                this.onEvents();
            }
        }
    };
});
